<template>
  <div
    :class="{'archive-hover-avatar position-relative': isHovered}"
    class="d-flex align-items-center justify-content-center w-4 h-4"
    title="Click to archive the company."
    @mouseenter="toggleHoverState"
    @mouseleave="toggleHoverState"
    @click="$emit('click')"
  >
  <!-- Note that the SVGs are not available as assets. 
       Thus they were copied from a `<b-icon />` component render.
       Do we want to keep it that way? Or create the files based on this code?
       Any other suggestions?
  -->
    <svg v-if="isHovered"
      alt="Archive icon"
      fill="white"
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      focusable="false"
      role="img"
      aria-label="pencil
      square"
      xmlns="http://www.w3.org/2000/svg"
      class="bi-pencil-square b-icon bi icon-hovered"
      style="font-size: 140%;">
      <g data-v-053e330a="">
        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456l-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"></path>
        <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"></path>
      </g>
    </svg>
    <svg v-else
      alt="Archive icon"
      fill="#082f46"
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      focusable="false"
      role="img"
      aria-label="pencil
      square"
      xmlns="http://www.w3.org/2000/svg"
      class="bi-pencil-square b-icon bi"
      style="font-size: 140%;">
      <g data-v-053e330a="">
        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456l-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"></path>
        <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"></path>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isHovered: false
    }
  },

  methods:  {
    toggleHoverState() {
      this.isHovered = !this.isHovered
    }
  }
}
</script>

<style scoped>
.icon-hovered {
  background-color: #074f89;
}
</style>